"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCustomMediaQueriesString = exports.toCustomPropertiesString = exports.toCustomMediaQueriesArray = exports.toCustomPropertiesArray = void 0;
const colord_1 = require("colord");
const change_case_1 = require("change-case");
const threeDigitHexPattern = /^#([a-f]|[A-F]|[0-9]){3}$/;
const sixDigitHexPattern = /^#([a-f]|[A-F]|[0-9]){6}$/;
const isHex = (hex) => {
    return threeDigitHexPattern.test(hex) || sixDigitHexPattern.test(hex);
};
const toCSSVariables = (object, options) => {
    const cssVariables = [];
    const addCSSVariable = (currentValue, parentKeys) => {
        Object.entries(currentValue).map(([key, value]) => {
            if (typeof value !== 'string' && typeof value !== 'number') {
                addCSSVariable(value, [...parentKeys, (0, change_case_1.paramCase)(key)]);
            }
            else {
                cssVariables.push({
                    key: `--${(options && options.prefix && `${options.prefix}-`) || ''}${[...parentKeys, key].join('-')}`,
                    value,
                });
            }
        });
    };
    addCSSVariable(object, []);
    return cssVariables;
};
const toCustomPropertiesArray = (object, options) => {
    if (options && options.withRGB) {
        return toCSSVariables(object, options).reduce((prev, { key, value }) => {
            if (!isHex(value.toString()))
                return [...prev, { key, value }];
            const { r, g, b } = (0, colord_1.colord)(value.toString()).toRgb();
            return [...prev, { key, value }, { key: `${key}-rgb`, value: `${r}, ${g}, ${b}` }];
        }, []);
    }
    return toCSSVariables(object, options);
};
exports.toCustomPropertiesArray = toCustomPropertiesArray;
const toCustomMediaQueriesArray = (object, options) => {
    return toCSSVariables(object, options);
};
exports.toCustomMediaQueriesArray = toCustomMediaQueriesArray;
const toCustomPropertiesString = (object, options) => {
    return (0, exports.toCustomPropertiesArray)(object, options)
        .map(({ key, value }) => `${key}: ${value};`)
        .join(' ');
};
exports.toCustomPropertiesString = toCustomPropertiesString;
const toCustomMediaQueriesString = (object, options) => {
    return (0, exports.toCustomMediaQueriesArray)(object, options)
        .map(({ key, value }) => `@custom-media ${key} ${value};`)
        .join(' ');
};
exports.toCustomMediaQueriesString = toCustomMediaQueriesString;
